module.exports = __webpack_public_path__ + "img/hk.74b1a9fb.svg";